export const SAVE                             = 'SAVE';
export const DESTROY                          = 'DESTROY';
export const GET                              = 'GET';

export const CLEAR_DATA                       = 'CLEAR_DATA';
export const UPDATE_DATA                      = 'UPDATE_DATA';

export const CLEAR_PLANNER                    = 'CLEAR_PLANNER'
export const UPDATE_PLANNER                   = 'UPDATE_PLANNER'
export const PLANNER_LINES                    = 'PLANNER_LINES'
export const PLANNER_LINES_CLEAR              = 'PLANNER_LINES_CLEAR'
export const PLANNER_TASKS                    = 'PLANNER_TASKS'
export const PLANNER_TASKS_CLEAR              = 'PLANNER_TASKS_CLEAR'
export const PLANNER_MEMOS                    = 'PLANNER_MEMOS'
export const PLANNER_MEMOS_CLEAR              = 'PLANNER_MEMOS_CLEAR'
export const PLANNER_TASKABLES                = 'PLANNER_TASKABLES'
export const PLANNER_TASKABLES_CLEAR          = 'PLANNER_TASKABLES_CLEAR'
export const PLANNER_LOCATIONS                = 'PLANNER_LOCATIONS'
export const PLANNER_LOCATIONS_CLEAR          = 'PLANNER_LOCATIONS_CLEAR'
export const PLANNER_SCHEDULES                = 'PLANNER_SCHEDULES'
export const PLANNER_SCHEDULES_CLEAR          = 'PLANNER_SCHEDULES_CLEAR'
export const PLANNER_ORDERS                   = 'PLANNER_ORDERS'
export const PLANNER_ORDERS_CLEAR             = 'PLANNER_ORDERS_CLEAR'

export const VALID_USER                       = 'VALID_USER';
export const VALID_HEAT_TREATMENT             = 'VALID_HEAT_TREATMENT';
export const VALID_MATERIAL                   = 'VALID_MATERIAL';
export const VALID_CLIENT                     = 'VALID_CLIENT';
export const VALID_PRODUCT                    = 'VALID_PRODUCT';
export const VALID_TEAM                       = 'VALID_TEAM';
export const VALID_LOCATION                   = 'VALID_LOCATION';
export const VALID_LOCATIONS_PERSON           = 'VALID_LOCATIONS_PERSON';
export const VALID_ORDER                      = 'VALID_ORDER';
export const VALID_SCHEDULE                   = 'VALID_SCHEDULE';
export const VALID_TASK                       = 'VALID_TASK';
export const VALID_TASKS_MEMO                 = 'VALID_TASKS_MEMO';
export const VALID_COMMENT                    = 'VALID_COMMENT';
export const VALID_DELIVERY_OPTION            = 'VALID_DELIVERY_OPTION';
